module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "rect1",
    style: ('background-color:' + _vm.color)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect2",
    style: ('background-color:' + _vm.color)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect3",
    style: ('background-color:' + _vm.color)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect4",
    style: ('background-color:' + _vm.color)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect5",
    style: ('background-color:' + _vm.color)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c2c9cf8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/components/loaders/Loader1.vue
// module id = 452
// module chunks = 42